import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';

import { MigrationStatus } from '@app/api/Migration/types';
import type { TAG_STATUS_DEFAULT } from '@app/constants/tagStatuses';
import {
  TAG_STATUS_ERROR,
  TAG_STATUS_PROCESSING,
  TAG_STATUS_SUCCESS,
  TAG_STATUS_WARNING,
} from '@app/constants/tagStatuses';

// Надписи статусов миграций
export const MIGRATION_WAITED_LABEL = 'Ожидает запуска';
export const MIGRATION_STOPPED_LABEL = 'Остановлена';
export const MIGRATION_RUNNING_LABEL = 'Запущена';
export const MIGRATION_SUCCESS_LABEL = 'Завершена';
export const MIGRATION_FAILED_LABEL = 'Ошибка';

// Действия с миграцией
export const MIGRATION_TOOLTIP_TO_START = 'Запустить миграцию';
export const MIGRATION_TOOLTIP_TO_STOP = 'Остановить миграцию';

export type MigrationTooltip =
  | typeof MIGRATION_TOOLTIP_TO_START
  | typeof MIGRATION_TOOLTIP_TO_STOP
  | null;

export type MigrationStatusLabel =
  | typeof MIGRATION_WAITED_LABEL
  | typeof MIGRATION_STOPPED_LABEL
  | typeof MIGRATION_RUNNING_LABEL
  | typeof MIGRATION_SUCCESS_LABEL
  | typeof MIGRATION_FAILED_LABEL;

export type MigrationStatusColor =
  | typeof TAG_STATUS_SUCCESS
  | typeof TAG_STATUS_PROCESSING
  | typeof TAG_STATUS_ERROR
  | typeof TAG_STATUS_WARNING
  | typeof TAG_STATUS_DEFAULT;

export type MigrationStatusMeta = {
  id: MigrationStatus;
  label: MigrationStatusLabel;
  color: MigrationStatusColor;
  icon: JSX.Element | null;
  tooltip: MigrationTooltip;
  hasManagementButton: boolean;
};

// Массив метаинформации по статусам миграций
export const MIGRATION_STATUSES: MigrationStatusMeta[] = [
  {
    id: MigrationStatus.Waited,
    label: MIGRATION_WAITED_LABEL,
    color: TAG_STATUS_PROCESSING,
    icon: null,
    tooltip: MIGRATION_TOOLTIP_TO_STOP,
    hasManagementButton: true,
  },
  {
    id: MigrationStatus.Stopped,
    label: MIGRATION_STOPPED_LABEL,
    color: TAG_STATUS_WARNING,
    icon: <MinusCircleOutlined />,
    tooltip: MIGRATION_TOOLTIP_TO_START,
    hasManagementButton: true,
  },
  {
    id: MigrationStatus.Running,
    label: MIGRATION_RUNNING_LABEL,
    color: TAG_STATUS_PROCESSING,
    icon: <SyncOutlined spin />,
    tooltip: MIGRATION_TOOLTIP_TO_STOP,
    hasManagementButton: true,
  },
  {
    id: MigrationStatus.Successed,
    label: MIGRATION_SUCCESS_LABEL,
    color: TAG_STATUS_SUCCESS,
    icon: <CheckCircleOutlined />,
    tooltip: null,
    hasManagementButton: false,
  },
  {
    id: MigrationStatus.Failed,
    label: MIGRATION_FAILED_LABEL,
    color: TAG_STATUS_ERROR,
    icon: <CloseCircleOutlined />,
    tooltip: MIGRATION_TOOLTIP_TO_START,
    hasManagementButton: true,
  },
];
